import { useRelayEnvironment } from 'react-relay/hooks';

function useRelayEnvironments() {
  const environment = useRelayEnvironment();
  return {
    environments: [environment],
    defaultEnvironment: environment,
  };
}

export default useRelayEnvironments;
